import { styled } from "@mui/material/styles";
import { Box, ListItem, Input, ListItemButton } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const StyledButtonWaze = styled(Box)({
  minWidth: 40,
});

export const StyledButtonWazeImage = styled("img")({
  height: 30,
});

export const StyledEmptyText = styled(Box)({
  marginLeft: 20,
});

export const StyledListItemText = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(3),
}));

export const StyledListItemTextOverflow = styled(Box)({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
});

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  paddingRight: 90,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export const StyledListItemError = styled(ListItem)(({ theme }) => ({
  paddingRight: 90,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  backgroundColor: theme.palette.error.light,
}));

export const StyledListItemIcon = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const StyledListHeader = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-end",
  flexWrap: "wrap",
}));

export const StyledListHeaderText = styled(Box)({
  fontWeight: "bold",
});

export const StyledMenuDaysPaper = styled(Box)({
  maxWidth: "100%",
});

export const StyledMenuDays = styled(Box)({
  width: 300,
});

export const StyledMenuDaysInput = styled(Input)(({ theme }) => ({
  width: 45,
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}));

export const StyledInput = styled(Input)({
  width: "100%",
  padding: "0.5rem",
  borderRadius: "0.5rem",
  border: "1px solid #e0e0e0",
  "&:focus": {
    outline: "none",
    borderColor: "#1976d2",
  },
});

export const StyledTreeListItem = styled(ListItemButton)(({ theme }) => ({
  paddingRight: 90,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  "& .MuiListItemText-primary": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  "& .MuiListItemText-secondary": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
}));

export const StyledTreeListItemError = styled(StyledTreeListItem)(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
}));
